/** Wraps an async function so that calls made while one is in flight share its promise. */
export const singleFlight = <T>(fn: () => Promise<T>) => {
  let inFlight: Promise<T> | null = null;

  return () => {
    if (!inFlight) {
      inFlight = fn().finally(() => {
        inFlight = null;
      });
    }
    return inFlight;
  };
};
